<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top">
    <div class="container hstack align-items-center">
      <!-- 좌측 로고/브랜드 -->
      <RouterLink class="r-pl-16 logo-link" to="/">
        <!-- 로고 이미지가 있으면 교체 -->
        <img src="@/assets/logo/pawinhand_logo_type2.png" alt="Pawinhand" />
        <!-- <span class="fw-semibold">PawInHand</span> -->
      </RouterLink>

      <!-- 모바일 토글 버튼 -->
      <!-- <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#mainNav"
        aria-controls="mainNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        >
        <span class="navbar-toggler-icon"></span>
      </button> -->

      <!-- 우측 메뉴 (모바일에서는 접힘) -->
      <!-- <div class="collapse navbar-collapse" id="mainNav"> -->
        <ul class="navbar-nav ms-auto hstack r-pr-16">
          <li class="nav-item">
            <RouterLink to="/" class="nav-link" exact-active-class="active">홈</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/shelter" class="nav-link" exact-active-class="active">보호소</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/lost" class="nav-link" exact-active-class="active">{{ $commonUtils.checkMobile() ? '실종' : '실종/제보'}}</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/story" class="nav-link" exact-active-class="active">스토리</RouterLink>
          </li>
        </ul>
      <!-- </div> -->
    </div>
  </nav>
</template>
<script>

export default {
  name: 'SiteHeader', 

  data() {
    return {
      
    }
  },
  methods: {

  },
  mounted(){

  },
  created (){

  },
  computed(){

  }
  
}
</script>


<style scoped>
    @import "@/css/common.css";
    @import "@/css/style.css";
/* 필요 시 커스텀 */
.navbar-brand img { display: block; }
.navbar-toggler{
  border : 0;
}
.navbar-toggler:focus {
  box-shadow: 0 0 0;
}
</style>